module.exports = __webpack_public_path__ + "static/img/icon-03.eb17cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/four-pillars/icon-03.png
// module id = tvSU
// module chunks = 1